import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
  })
export class SaguiClienteService {
getSegmento(skipLoader = false): Observable<HttpResponse<any>> {

  const headers = skipLoader ? new HttpHeaders().set('X-Skip-Loader', 'true') : new HttpHeaders();

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/saguicliente/saguicliente-segmento', { headers, observe: 'response' })
  }

  getUrlPorSegmento(skipLoader = false): Observable<any> {
    return this.getSegmento(skipLoader).pipe(
        map(data => data.body)
    );
}

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
